import styles from "./ToTopButton.module.css";
import arrow from "../../assets/arrow.png";

export default function ToTopButton() {
  return (
    <div
      className={styles.container}
      onClick={() =>
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })
      }
    >
      <img className={styles.img} src={arrow} alt=">" />
    </div>
  );
}
